import { render, staticRenderFns } from "./check-34.vue?vue&type=template&id=1e8b36be&scoped=true"
import script from "./check-34.vue?vue&type=script&lang=js"
export * from "./check-34.vue?vue&type=script&lang=js"
import style0 from "./check-34.vue?vue&type=style&index=0&id=1e8b36be&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b36be",
  null
  
)

export default component.exports